import axios from "axios";

const base = process.env.REACT_APP_BACK_URL || `${window.location.protocol}//${window.location.hostname}:5000`;

type Headers = { headers?: Record<string, string> };

const auth = (token?: string): Headers =>
  token
    ? {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    : {};

export type ServicioCatalogo = {
  id: number;
  servicio_id?: number;
  nombre: string;
  descripcion?: string;
  categoria?: string;
  icono?: string;
  activo?: boolean;
};

export type ServicioAsignacion = {
  socio_id?: number | string;
  socio_nombre?: string;
  socio_mail?: string;
  socio_celular?: string;
};

export const obtenerServiciosCatalogo = async (token?: string) => {
  const { data } = await axios.get<ServicioCatalogo[]>(
    `${base}/servicios`,
    auth(token)
  );
  return data;
};

export const crearServicio = async (
  payload: {
    nombre: string;
    descripcion?: string;
    categoria?: string;
    icono?: string;
    activo?: boolean;
  },
  token?: string
) => {
  const { data } = await axios.post(`${base}/servicios`, payload, auth(token));
  return data;
};

export const actualizarServicio = async (
  servicioId: number,
  payload: {
    nombre?: string;
    descripcion?: string;
    categoria?: string;
    icono?: string;
    activo?: boolean;
  },
  token?: string
) => {
  const { data } = await axios.put(`${base}/servicios/${servicioId}`, payload, auth(token));
  return data;
};

export const eliminarServicio = async (servicioId: number, token?: string) => {
  const { data } = await axios.delete(`${base}/servicios/${servicioId}`, auth(token));
  return data;
};

export const asociarSocioAServicio = async (
  payload: {
    socioId: number;
    servicioId: number;
    notas?: string;
    contacto?: {
      email?: string;
      telefono?: string;
      nombre?: string;
    };
  },
  token?: string
  ) => {
  const { data } = await axios.post(
    `${base}/servicios/asociaciones`,
    payload,
    auth(token)
  );
  return data;
};

export const obtenerAsignacionesDeServicio = async (servicioId: number, token?: string) => {
  const { data } = await axios.get<ServicioAsignacion[]>(
    `${base}/servicios/asociaciones/${servicioId}`,
    auth(token)
  );
  return data;
};

export const obtenerServiciosDeSocio = async (socioId: number, token?: string) => {
  const { data } = await axios.get(
    `${base}/servicios/asociaciones/socio/${socioId}`,
    auth(token)
  );
  return data;
};

export const eliminarAsociacion = async (
  socioId: number,
  servicioId: number,
  token?: string
) => {
  const { data } = await axios.delete(
    `${base}/servicios/asociaciones/${socioId}/${servicioId}`,
    auth(token)
  );
  return data;
};

export type SolicitudServicioPayload = {
  socioId?: number;
  servicioId?: number;
  servicio: string;
  nombre: string;
  email: string;
  telefono?: string;
  comentarios?: string;
};

export type SolicitudServicioItem = {
  solicitud_id: number;
  socio_id?: number;
  servicio_id?: number;
  servicio: string;
  nombre: string;
  email: string;
  telefono?: string;
  comentarios?: string;
  estado: 'pendiente' | 'aprobada' | 'rechazada';
  creado_en: string;
};

export const crearSolicitudServicio = async (
  payload: SolicitudServicioPayload,
  token?: string
) => {
  const { data } = await axios.post(
    `${base}/solicitudes-servicio`,
    payload,
    auth(token)
  );
  return data;
};

export const listarSolicitudesServicio = async (
  params?: { estado?: string; socioId?: number },
  token?: string
) => {
  const { data } = await axios.get<SolicitudServicioItem[]>(`${base}/solicitudes-servicio`, {
    ...(auth(token) || {}),
    params,
  });
  return data;
};

export const aprobarSolicitudServicio = async (solicitudId: number, token?: string) => {
  const { data } = await axios.patch(`${base}/solicitudes-servicio/${solicitudId}/aprobar`, {}, auth(token));
  return data;
};
